import styled from "styled-components";
import CustomHead from "src/components/ui/CustomHead";
import Layout from "src/layout";
import Demo from "src/components/containers/demo/Demo";
import { colors } from "src/theme/colors";
import { GetStaticProps } from "next";
import useAllPage from "src/hooks/dynamic/allPage";

const Wrapper = styled.div`
  background-color: ${colors.main};
  overflow: hidden;
`;

export default function GetTheAppPage() {
  return (
    <>
      <CustomHead />

      <Wrapper>
        <Layout headerProps={{ styles: { width: "1096px" } }}>
          <Demo />
        </Layout>
      </Wrapper>
    </>
  );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const initialReduxState = await useAllPage(ctx.locale as string);

  return {
    props: {
      initialReduxState: { DYNAMIC: initialReduxState.DYNAMIC },
    },
    revalidate: 600, // 10 Minutes Cache
  };
};
